export default "__VITE_ASSET__1$FXE3n___"